var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 即将跳转到支付页面 "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.payGateWay)}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }